<template>
  <div class="login-by-phone">
    <!-- 验证码登录 -->
    <el-form ref="ruleForm2" label-position="left" label-width="0" :model="form2" :rules="rules">
      <el-form-item size="large" prop="phone">
        <el-input
          autocomplete="on"
          v-model="form2.phone"
          name="username"
          type="text"
          :placeholder="langList && langList.mobilePhone ? langList.mobilePhone : '手机号'"
          @keyup.enter.native="loginByPhone"
        ></el-input>
      </el-form-item>
      <el-form-item size="large" prop="captcha">
        <div class="captcha_box">
          <el-input
            autocomplete="on"
            v-model="form2.captcha"
            name="captcha"
            style="flex:1;"
            :placeholder="
              langList && langList.captcha && langList.send
                ? langList.send + langList.captcha
                : '发送验证码'
            "
            @keyup.enter.native="loginByPhone"
          >
          </el-input>

          <el-button
            v-if="verify_time != 0 && verify_time > 0"
            type="info"
            plain
            class="captcha_time_btn"
            >{{ verify_time }}
            {{ langList && langList.seconds ? langList.seconds : '秒' }}</el-button
          >
          <el-button v-else type="primary" class="send_captcha_btn" @click="getVerificationCode">{{
            langList && langList.captcha && langList.send
              ? langList.send + langList.captcha
              : '发送验证码'
          }}</el-button>
        </div>
      </el-form-item>
      <el-button class="login-btn" @click="loginByPhone">
        {{ langList && langList.login ? langList.login : '登录' }}
      </el-button>
    </el-form>
    <!-- 多个账号 -->
    <el-dialog
      title="选择登录账号"
      :center="true"
      :visible.sync="dialogSelectAccount"
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="dialogSelectAccount"
    >
      <div v-if="selectAccountData && selectAccountData.length" v-loading="is_login">
        <el-card
          v-for="(item, index) in selectAccountData"
          shadow="hover"
          :key="'user' + index"
          @click.native="clickAccount(item)"
        >
          <span>{{ item.username }}</span
          ><span style="color: #909399;">{{ item.company_name }}</span>
        </el-card>
      </div>
      <div v-else style="text-align:center;padding-bottom:15px;" v-loading="is_login">账号信息</div>
    </el-dialog>
  </div>
</template>
<script>
// getLangList,
import { setToken, getVerificationCode, loginByPhone, selectAccount } from '@/model/login.js'
// import { getCookieKey, stringToMd5 } from '@/common/util-front.js';

export default {
  data() {
    const isCn = window.RENDER_DATA && window.RENDER_DATA.isCn
    // console.log('window.RENDER_DATA.verify_time', window.RENDER_DATA.verify_time)
    return {
      verify_time: 0,
      isCn: isCn,
      langList: {},
      form2: {
        phone: '',
        captcha: ''
      },
      timer: '',
      is_login: false,
      dialogSelectAccount: false,
      selectAccountData: []
    }
  },
  computed: {
    rules() {
      return {
        phone: [
          {
            required: true,
            message: '请输入手机号'
          }
        ],
        captcha: [
          {
            required: true,
            message: '请输入验证码'
          }
        ]
      }
    }
  },
  mounted() {},
  methods: {
    // 发送验证码计时
    countdownVerification() {
      const self = this
      if (self.verify_time && self.verify_time > 0) {
        self.timer = setInterval(function() {
          if (self.verify_time <= 0 || !self.verify_time) {
            clearInterval(self.timer)
          }
          self.verify_time--
        }, 1000)
      }
    },
    // 验证码登录
    loginByPhone() {
      const self = this
      if (self.is_login) return
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          loginByPhone({
            phone: self.form2.phone,
            verification_code: self.form2.captcha
          }).then(res => {
            if (res.code == 0) {
              if (res.data.type == 1) {
                // 只绑定一个账号
                self.is_login = true
                self.$message.success(
                  self.langList && self.langList.loginSuccess
                    ? this.langList.loginSuccess
                    : '登录成功！'
                )
                self.loginedFun && self.loginedFun()
                setToken().then(res2 => {})
                if (res.data && res.data.url) {
                  console.log('res.data.url', res.data.url)
                  window.location.href = res.data.url
                }
              } else if (res.data.type == 2) {
                // 绑定了多个账号
                self.selectAccountData = res.data.user_list
                self.dialogSelectAccount = true
              } else {
                self.$message.error('登录失败！')
              }
            }
          })
        }
      })
    },
    clickAccount(data) {
      // 绑定多个账号，选择账号登录
      const self = this
      console.log('clickAccount', data)
      selectAccount({
        username: data.username,
        password: data.password
      }).then(res => {
        if (res.code == 0) {
          self.is_login = true
          self.$message.success(
            self.langList && self.langList.loginSuccess ? self.langList.loginSuccess : '登录成功！'
          )
          setToken().then(res2 => {
            if (res2.code !== 0) {
              throw Error(res2.message)
            }
          })
          if (res.data && res.data.url) {
            console.log('res.data.url', res.data.url)
            window.location.href = res.data.url
          }
        }
      })
    },
    // 获取手机验证码
    getVerificationCode() {
      const self = this
      if (self.form2.phone) {
        getVerificationCode({
          phone: self.form2.phone
        }).then(res => {
          // console.log('res getVerificationCode', res)
          if (res.code === 0) {
            // 发送短信成功，设置60秒内不能再次触发
            self.verify_time = 60
            self.countdownVerification()
            self.$message({
              type: 'success',
              message: '发送成功'
            })
          } else if (res.code == 666) {
            // 60s内已触发过短信发送
            self.verify_time = res.data.time
            self.countdownVerification()
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-by-phone {
  .send_captcha_btn {
    min-width: 200px;
    /* prettier-ignore */
    margin-left: 15Px;
    /* prettier-ignore */
    padding: 0 10Px;
    background: #3665ec;
    color: #fff;
    border: #3665ec;
  }
  .captcha_box {
    display: flex;
  }
  .captcha_time_btn {
    min-width: 200px;
    margin-left: 10px;
  }
  .login-by-phone {
    /deep/ .el-button--info.is-plain:focus {
      color: #909399;
      background: #f4f4f5;
      border-color: #d3d4d6;
    }
  }
}
</style>
<style lang="scss">
.dialogSelectAccount {
  width: 30%;
  /* prettier-ignore */
  min-width: 335Px;
  /* prettier-ignore */
  max-width: 450Px;
  .el-card {
    /* prettier-ignore */
    margin-bottom: 10Px;
  }
  .el-card__body {
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width: 640px) {
    .el-dialog__title {
      /* prettier-ignore */
      font-size: 14Px;
    }
    .el-dialog__header {
      /* prettier-ignore */
      padding:15Px;
    }
    .el-card__body {
      /* prettier-ignore */
      padding: 10Px !important;
    }
    .el-dialog__body {
      /* prettier-ignore */
      padding: 10Px !important;
    }
    .el-card.is-hover-shadow:hover {
      /* prettier-ignore */
      box-shadow: 5Px 5Px 5Px 0 rgba(0,0,0,.1) !important
    }
  }
}
</style>
